import type { RouteSeo } from '@/shared/seo/types';

export const storeGiftCardSeo: RouteSeo = {
  title: 'BlueStone Physical Gift Card | Buy Gift Cards Online',
  description:
    'Buy BlueStone physical gift cards online. Choose your amount, add recipient details, and gift timeless jewellery.',
  canonical: 'https://www.bluestone.com/store-giftcard',
  robots: 'index, follow',
  meta: [
    { property: 'og:site_name', content: 'BlueStone' },
    { property: 'og:url', content: 'https://www.bluestone.com/store-giftcard' },
    {
      property: 'og:title',
      content: 'BlueStone Physical Gift Card | Buy Gift Cards Online',
    },
    {
      property: 'og:description',
      content:
        'Buy BlueStone physical gift cards online. Choose your amount, add recipient details, and gift timeless jewellery.',
    },
    { name: 'twitter:card', content: 'Summary' },
    { name: 'twitter:site', content: '@bluestone_com' },
    {
      name: 'twitter:title',
      content: 'BlueStone Physical Gift Card | Buy Gift Cards Online',
    },
    {
      property: 'twitter:description',
      content:
        'Buy BlueStone physical gift cards online. Choose your amount, add recipient details, and gift timeless jewellery.',
    },
    { name: 'twitter:url', content: 'https://www.bluestone.com/store-giftcard' },
  ],
};
